import request from 'services/api'

const api = {
    getMeasuresExport: (organisationId, startdate, enddate) => {
        return request
            .get(`/export/incident_measures.xlsx?organisationId=${organisationId}&startdate=${startdate}&enddate=${enddate}`, { responseType: 'blob' })
    },

    getAdditionalQuestionsExport: (organisationId, startdate, enddate) => {
        return request
            .get(`/export/incident_additional_questions.xlsx?organisationId=${organisationId}&startdate=${startdate}&enddate=${enddate}`, { responseType: 'blob' })
    },

    getIncidentsExport: (organisationId, startdate, enddate) => {
        return request
            .get(`/export/incidents.xlsx?organisationId=${organisationId}&startdate=${startdate}&enddate=${enddate}`, { responseType: 'blob' })
    }
}

export default api
